import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    
    if (!consent) {
      setShowConsent(true);
    } else if (consent === 'accepted' || consent === 'essential') {
      // Update consent mode to granted since user previously accepted
      updateConsentMode(true);
    }
  }, []);

  const updateConsentMode = (consent) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        'ad_storage': consent ? 'granted' : 'denied',
        'ad_user_data': consent ? 'granted' : 'denied',
        'ad_personalization': consent ? 'granted' : 'denied',
        'analytics_storage': consent ? 'granted' : 'denied',
        'functionality_storage': consent ? 'granted' : 'denied',
        'personalization_storage': consent ? 'granted' : 'denied',
        'security_storage': 'granted'
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
    updateConsentMode(true);
    
    // Track consent acceptance
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'cookie_consent_accepted', {
        'event_category': 'consent',
        'event_label': 'user_accepted_cookies'
      });
    }
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setShowConsent(false);
    updateConsentMode(true); // Grant analytics for essential cookies too
    
    // Track essential consent acceptance
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'cookie_consent_essential', {
        'event_category': 'consent',
        'event_label': 'user_accepted_essential_cookies'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
    updateConsentMode(false);
    
    // Track consent decline
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'cookie_consent_declined', {
        'event_category': 'consent',
        'event_label': 'user_declined_cookies'
      });
    }
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-popup">
        <div className="cookie-consent-content">
          <h3>Cookie Consent</h3>
          <p>
            We use cookies, primarily Google Analytics, to understand which information is useful for our customers and improve the quality of the information we provide. 
            By clicking "Accept", you consent to our use of cookies and Google Analytics.
          </p>
          <div className="cookie-consent-buttons">
            <button 
              className="cookie-button accept" 
              onClick={handleAccept}
            >
              Accept
            </button>
            <button 
              className="cookie-button essential" 
              onClick={handleEssentialOnly}
            >
              Only Essential
            </button>
            <button 
              className="cookie-button decline-small" 
              onClick={handleDecline}
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
